import { render } from "./_Table.vue?vue&type=template&id=cde2e9fa&scoped=true"
import script from "./_Table.vue?vue&type=script&lang=js"
export * from "./_Table.vue?vue&type=script&lang=js"

import "./_Table.vue?vue&type=style&index=0&id=cde2e9fa&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-cde2e9fa"

export default script